import React, { memo } from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';

interface CheckboxWithLabelProps {
  checked: boolean;
  label: string;
  onChange: () => void;
  labelPlacement?: 'start' | 'end' | 'top' | 'bottom';
  indeterminate?: boolean;
}

const CheckboxWithLabelComponent: React.FC<CheckboxWithLabelProps> = ({
  checked,
  label,
  onChange,
  labelPlacement = 'start',
  indeterminate = false,
}) => {
  return (
    <FormControlLabel
      labelPlacement={labelPlacement}
      sx={{
        width: '100%',
        margin: 0,
        '.MuiFormControlLabel-label': {
          flex: 1,
        },
      }}
      control={<Checkbox checked={checked} indeterminate={indeterminate} onChange={onChange} />}
      label={label}
    />
  );
};

export const CheckboxWithLabel = memo(CheckboxWithLabelComponent);
